import * as WalletModel from 'models/wallet';

import { API_PATH } from 'constants/app';
import { api } from 'helper/api';
import { formatE164Phone } from 'helper/form';

export function getTransactionList(transactionListFilter: WalletModel.WalletTransactionListFilter): Promise<WalletModel.WalletTransactionList> {
  return api.build().get(`${API_PATH}/accounts/me/wallet/transactions`, { ...transactionListFilter });
}

export function getTransactionSummary(): Promise<WalletModel.WalletTransactionSummary> {
  return api.build().get(`${API_PATH}/accounts/me/wallet/transactions/summary`);
}

export function getWalletAccount(): Promise<WalletModel.WalletAccount> {
  return api.build().get(`${API_PATH}/accounts/me/wallet`);
}

export function topUp(formValue: WalletModel.WalletTopUpForm): Promise<WalletModel.WalletTopUpResponse> {
  return api.build().withOAuth()
    .post(`${API_PATH}/accounts/me/wallet/top-ups`, {
      amount: formValue.amount
    });
}

export function getRedeemAccountList(walletRedeemAccountListFilter: WalletModel.WalletRedeemAccountListFilter): Promise<WalletModel.WalletRedeemAccountList> {
  return api.build().get(`${API_PATH}/accounts/me/wallet/redeems/banks`, { ...walletRedeemAccountListFilter });
}

export function redeem(walletRedeemForm: WalletModel.WalletRedeemOtpForm): Promise<WalletModel.WalletRedeem> {
  return api.build().post(`${API_PATH}/accounts/me/wallet/redeems`, { ...walletRedeemForm });
}

export function getBankList(walletBankListFilter: WalletModel.WalletBankListFilter): Promise<WalletModel.WalletBankList> {
  return api.build().get(`${API_PATH}/accounts/me/wallet/banks`, { ...walletBankListFilter });
}

export function transfer(walletTransferForm: WalletModel.WalletTransferOtpForm): Promise<WalletModel.WalletTransferOut> {
  return api.build().post(`${API_PATH}/accounts/me/wallet/transfers`, {
    amount: walletTransferForm.amount,
    destinationPhone: formatE164Phone(walletTransferForm.destinationPhone),
    otp: walletTransferForm.otp
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/repositories/wallet.ts